<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">عرض البيانات</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />
    <!--begin::Body-->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">مقدم الطلب:</label>
          <div>{{ (dataRow.User)? dataRow.User.name : 'غير معروف' }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">باسم:</label>
          <div>{{ dataRow.name }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">رقم الجوال:</label>
          <div>{{ dataRow.mobile }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">البريد الإلكتروني:</label>
          <div>{{ dataRow.email }}</div>
        </div>
      </div>

      <div class="row">
        <div v-if="dataRow.Region" class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">المنطقة:</label>
          <div>{{ dataRow.Region.name }}</div>
        </div>
        <div v-if="dataRow.City" class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">المدينة:</label>
          <div>{{ dataRow.City.name }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">خط العرض (Latitude):</label>
          <div>{{ dataRow.latitude || '-' }}</div>
        </div>

        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">خط الطول (Longitude):</label>
          <div>{{ dataRow.longitude || '-' }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">وصف العقار:</label>
          <div>{{ dataRow.description }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">تاريخ الطلب:</label>
          <div class="date-format">{{ formatDate(dataRow.createdAt) }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">رقم الصك:</label>
          <div class="date-format">{{ dataRow.receiptNumber }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">حالة الطلب:</label>
          <div>{{ statusChoices[status] }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">مصدر الطلب:</label>
            <div>
              <span v-if="dataRow.requestSource === 'admin'" class="badge bg-secondary">Admin</span>
              <span v-else-if="dataRow.requestSource === 'ios'" class="badge bg-primary">IOS</span>
              <span v-else-if="dataRow.requestSource === 'android'" class="badge bg-primary">Android</span>
              <span v-else-if="dataRow.requestSource === 'website'" class="badge bg-info">Website</span>
              <span v-else-if="dataRow.requestSource" class="badge bg-light text-dark">{{ dataRow.requestSource }}</span>
              <span v-else class="text-muted">غير محدد</span>
            </div>
        </div>  
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">سبب الرفض - في حالة الرفض:</label>
          <div>{{ note }}</div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import { formatDate } from '@/helpers/tools';

export default {
  name: 'ManagementReqsView',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    statusObject: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      statusChoices: {},
      status: 'new',
      note: '',
    }
  },
  methods: {
    formatDate,
  },
  created(){
    if(this.dataRow){
      this.status = this.dataRow.status;
      this.note = this.dataRow.note;
    }
    this.statusChoices = this.statusObject;
  }
}
</script>
